<template>
  <div>
    <p class="type-small no-bottom-margin color-off-black type-bold">{{ priceOutput }}</p>
    <p class="type-x-small no-bottom-margin color-silver-dark">{{ optionsCount }}</p>
  </div>
</template>

<script>

import axios from 'axios';

import { mapState } from 'vuex';

export default {
  name: 'PriceRangeProduct',
  props: ['productId'],
  methods: {

    getMatchedProduct() {
      return this.products.find(item => item.ProductId == this.productId);
    },

  },
  computed: {
    ...mapState({
      products: state => state.PriceRangeStore.productPrices,
    }),

    priceOutput() {
      const product = this.getMatchedProduct();
      return (typeof product !== 'undefined') ? product.ProductPrice.Price : '';
    },

    optionsCount() {
      const product = this.getMatchedProduct();
      let count = 1;
      if(typeof product !== 'undefined'){
        // count = product.ProductPrice.length;
        count = 1;
        return (count == 1) ? `${count} option` : `${count} options`;
      }

      return '';
    },
  }
}

</script>


// WEBPACK FOOTER //
// resources/assets/js/components/PriceRangeProduct.vue